import React, {useEffect, useRef, useState} from "react";
import {useLoad} from "../../context";
import ApiServices from "../../services/apiServices";
import {agruparPorCategoria} from "../../utils/faqCategorias";
import "./index.css";

function CategoryItems({cat, isOpen}) {
  const containerRef = useRef(null);
  const innerRef = useRef(null);
  const isFirstRender = useRef(true);
  const onEndRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (onEndRef.current) {
      container.removeEventListener("transitionend", onEndRef.current);
      onEndRef.current = null;
    }

    if (isOpen) {
      const h = innerRef.current.scrollHeight + 20;
      container.style.transition = "none";
      container.style.maxHeight = "0px";
      container.offsetHeight; //eslint-disable-line no-unused-expressions
      container.style.transition = "max-height 0.5s ease-out";
      container.style.maxHeight = h + "px";
      onEndRef.current = () => {
        container.style.maxHeight = "99999px";
      };
      container.addEventListener("transitionend", onEndRef.current, {once: true});
    } else {
      const currentH = container.scrollHeight;
      container.style.transition = "none";
      container.style.maxHeight = currentH + "px";
      container.offsetHeight; //eslint-disable-line no-unused-expressions
      container.style.transition = "max-height 0.4s ease-in";
      container.style.maxHeight = "0px";
    }
  }, [isOpen]);

  return (
    <div
      className="faq-category-items"
      ref={containerRef}
      style={{maxHeight: 0, overflow: "hidden"}}
    >
      <div ref={innerRef}>
        {cat.items.map((e, i) => (
          <div key={i} className="accordion accordion-flush" id={`accordionCat${cat.id}Item${i}`}>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed tituloFaq"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapseCat${cat.id}Item${i}`}
                  aria-expanded="false">
                  {e.titulo.toUpperCase()}
                </button>
              </h2>
              <div
                id={`collapseCat${cat.id}Item${i}`}
                className="accordion-collapse collapse textFaq"
                data-bs-parent={`#accordionCat${cat.id}Item${i}`}>
                <div className="accordion-body">
                  {e.urlImagem && (
                    <img className="faq-image" src={e.urlImagem} alt={e.titulo} />
                  )}
                  <div dangerouslySetInnerHTML={{__html: e.texto}} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function Faq() {
  const {load, setLoad} = useLoad();
  const [faq, setFaq] = useState([]);
  const [termoPesquisa, setTermoPesquisa] = useState("");
  const [faqFiltrado, setFaqFiltrado] = useState([]);
  const [categoriaAberta, setCategoriaAberta] = useState(null);

  async function fnFaq() {
    try {
      setLoad(true);
      let response = await ApiServices.apiGet("faq/de-participante");
      setFaq(response.data);
      setFaqFiltrado(response.data.filter((e) => e.logado));
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  useEffect(() => {
    fnFaq();
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (termoPesquisa === "") {
      setFaqFiltrado(faq.filter((e) => e.logado));
    } else {
      const filtrado = faq.filter(
        (e) =>
          e.logado &&
          (e.titulo.toLowerCase().includes(termoPesquisa.toLowerCase()) ||
            e.texto.toLowerCase().includes(termoPesquisa.toLowerCase()))
      );
      setFaqFiltrado(filtrado);
    }
    setCategoriaAberta(termoPesquisa !== "" ? "all" : null);
  }, [termoPesquisa, faq]);

  const toggleCategoria = (catId) => {
    setCategoriaAberta(categoriaAberta === catId ? null : catId);
  };

  const categoriasAgrupadas = agruparPorCategoria(faqFiltrado);

  return (
    <>
      <div className="faq-container">
        <div className="faq-content">
          <h1 className="faq-title">Perguntas Frequentes</h1>

          <div className="faq-search-container">
            <input
              type="text"
              className="form-control faq-search-input"
              placeholder="Pesquisar no perguntas frequentes"
              value={termoPesquisa}
              onChange={(e) => setTermoPesquisa(e.target.value)}
            />
          </div>

          <div className="faq-accordion-container">
            {faqFiltrado.length === 0 ? (
              <div className="faq-empty-message">
                <p>Nenhuma pergunta encontrada.</p>
              </div>
            ) : (
              categoriasAgrupadas.map((cat) => (
                <div key={cat.id} className="faq-category-group">
                  <div
                    className={`faq-category-header ${(categoriaAberta === "all" || categoriaAberta === cat.id) ? "open" : ""}`}
                    onClick={() => toggleCategoria(cat.id)}
                  >
                    <span>{cat.label}</span>
                    <div className="faq-category-right">
                      {!(categoriaAberta === "all" || categoriaAberta === cat.id) && <span className="faq-hint-cat">Clique Aqui</span>}
                      <span className={`faq-category-icon ${(categoriaAberta === "all" || categoriaAberta === cat.id) ? "open" : ""}`}>{(categoriaAberta === "all" || categoriaAberta === cat.id) ? "−" : "+"}</span>
                    </div>
                  </div>
                  <CategoryItems cat={cat} isOpen={categoriaAberta === "all" || categoriaAberta === cat.id} />
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
}
